import { Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const KeyFeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  background-color: ${(p) => p.theme.colors.background2};
  margin-top: 2rem;
  padding: 1.5rem;
  border-radius: 0.5rem;
`;

export const KeyFeaturesWrapperPrint = styled(KeyFeaturesWrapper)`
  background-color: transparent;
  margin-top: 0;

  @media print {
    gap: 0;
    margin-top: 0;
    padding: 0;
  }
`;

export const KeyFeaturesGrid = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem 1.5rem;
  padding: 0 0.5rem;
  width: 100%;
  max-width: 840px;

  > * {
    min-width: 120px;
    max-width: 200px;
    flex: 1;
  }
`;
